import { render, staticRenderFns } from "./UcContractStatusCard.yaml?vue&type=template&id=63d8ad8a&component"
import script from "./UcContractStatusCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractStatusCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports